import { singleton } from "tsyringe";
import EventEmitter from "eventemitter3";
import { TPaintingData } from "./config/paintings";

interface IEventBusEvents {
  "dragger/pointerOver": [];
  "dragger/pointerOut": [];
  "navBtn/pointerOver": [];
  "navBtn/pointerOut": [];
  "navBtn/home": [];
  "navBtn/next": [];
  "navBtn/prev": [];
  "navBtn/day": [];
  "dragger/grab": [];
  "dragger/release": [];
  'resize': [];
  "dragger/progress": [value: number];
  "painting/click": [painting: TPaintingData];
}
@singleton()
export class EventBus extends EventEmitter<IEventBusEvents> {}
